import p1 from '../Assets/images/Products/img01.webp'
import p2 from '../Assets/images/Products/Air force 1.webp'
import p3 from '../Assets/images/Products/Air jordan 1.webp'
import p4 from '../Assets/images/Products/Chuk 70 high.webp'

     let data_products =[
        {
            id: 1,
            name:"Air force 1 LV8",
            img: p1,
            new_price:'10,795',

        },
        {
            id: 2,
            name:'Air force 1',
            img: p2,
            new_price:'7,495',
            

        },
        {
            id: 3,
            name:'Air jordan 1',
            img: p3,
            new_price:'8,695',
            

        },
        { 
            id: 4,
            name:'Chuk 70 high',
            img: p4,
            new_price:'6000',
            

        },
        
       ]

export default data_products;